import React from 'react';
import { useEffect, useState } from "react";
import { Oval } from "react-loader-spinner";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import SetUpForMobile from "./timedAuction/setUpForMobile";
import { dataService } from "../../../services/dataService";
import Banner from "../../../components/layout/notificationbannar";

export default function Header(props){

    const { priceError,lotData,createLothandler,loading,auctionData,setLotData,
        setPriceError, isBanner, setIsBanner, edit, lotNavigation, lotNumber,
        handleNextClick, handlePrevClick, hasChanges, text, setText, localImages,
        setOpenExitModal, mandatoryFieldsFilled, setLocalImages, oldS3Images, setOldS3Images }=props;
    const {id,uid}=useParams();
    const [isOpen, setIsOpen] = useState(true)
    const Navigate=useNavigate();
    const location = useLocation();

    const [notes , setNotes] = useState({});
    const [istextShow , setIstextShow] = useState(false);

    const [screenWidth, setScreenWidth] = useState(window.innerWidth);

    const isSaveDisabled = () => {
        if (priceError || loading) return true;
        
        if (edit) {
            return !hasChanges() || !mandatoryFieldsFilled();
        } else {
            return !mandatoryFieldsFilled();
        }
    };

    const handleBackClick = () => {
        if (hasChanges()) {
            setIsOpen(false);
            setOpenExitModal('back');
        } else {
            Navigate(`/auctions/${id}/${uid}/lots${location.state.search ? location.state.search : ''}`);
        }
    };

    const handlePrevLot = () => {
        if (lotNavigation.prev == null) return;
        if (hasChanges()) {
            setOpenExitModal('prev');
        } else {
            handlePrevClick();
        }
    };

    const handleNextLot = () => {
        if (lotNavigation.next == null) return;
        if (hasChanges()) {
            setOpenExitModal('next');
        } else {
            handleNextClick();
        }
    };

    const numberOfChars=()=>{
        if(screenWidth > 1130){
            return 200
        }else if(screenWidth>1102){
            return 130
        }else if(screenWidth> 774){
            return 60
        }else if(screenWidth > 418){
            return 50;
        }else{
            return 20;
        }
    }

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = notes?.notification;

    
    const allPs = tempDiv.querySelectorAll('p');  // Get all <p> tags
    const firstP = allPs[0];  // Get the first <p> tag
    const secondPExists = allPs.length > 1;

    const displayContent= notes?.notification?.length> numberOfChars() || secondPExists;
    const notificationContent= istextShow ? notes?.notification : firstP?.outerHTML.substring(0, numberOfChars()-6);
    const buttonText = istextShow ? 'Read less' : 'Read more';


    const handleResize = () => {
        setScreenWidth(window.innerWidth);
    };
  
    // Attach event listener when the component renders
    window.addEventListener('resize', handleResize);

    const viewBanner=async()=>{
        const response=await dataService.BannerNotification();
        if(response.error===false){
            setNotes(response.data.data);
            setIsBanner(false)
        }
        else{
            setIsBanner(true)
        }
    }

    const toggleFullText= () =>{
        setIstextShow(!istextShow);
    }

    useEffect(()=>{
        viewBanner()
    },[])    

    return(
        <>
            <Banner viewBanner={viewBanner} notes={notes} setNotes={setNotes} toggleFullText={toggleFullText} 
                displayContent={displayContent} notificationContent={notificationContent} buttonText={buttonText}
                istextShow={istextShow} />
            <nav className={`h-[68px] md:px-10 px-5 flex border-b border-[#D4D4D8] justify-between 
                overflow-x-hidden sticky  ${isBanner ? 'top-0 md:top-0': 'top-[45px] md:top-[45px] z-[999]'} 
                md:z-[10] z-[101] bg-[#FFFFFF]`}>
                <div className="flex items-center">
                    <img src="/images/arrow-left-dark.svg" className="cursor-pointer"  alt="img" 
                        onClick={handleBackClick} data-testid='back-btn'/>
                    <p className="md:block hidden pl-5 py-5" data-testid='back'>Back to Lot List View</p>
                </div>
                {edit && <>
                    <button onClick={handlePrevLot}
                        disabled={lotNavigation.prev == null || loading}
                        className={`${(lotNavigation.prev == null || loading) && 'opacity-50'}
                            mt-1 text-[14px]`}>
                        <img src="/images/prev.svg" className="mx-auto w-30 h-30"  alt="prev-img" data-testid='prev-btn'/>
                        <p className='hidden sm:block' >Previous Lot</p>
                    </button>
                    <button onClick={handleNextLot}
                        disabled={lotNavigation.next == null || loading}
                        className={`${(lotNavigation.next == null || loading) && 'opacity-50'}
                            mt-1 text-[14px]`}>
                        <img src="/images/next.svg" className="mx-auto w-30 h-30"  alt="next-img" data-testid='next-btn'/>
                        <p className='hidden sm:block' >Next Lot</p>
                    </button>
                </>}
                <div className='flex justify-end items-center'>
                    <button id="preview-btn"  onClick={()=>setIsOpen((prevState) => !prevState)} 
                        className={`md:hidden block border border-[#282828] rounded-md text-[14px] text-[#282828] 
                leading-normal font-medium px-[20px] py-[12px] ${isOpen ? "w-[110px]" : "w-[165px]"} 
                md:w-[135px] bg-[#FFFFFF] mr-2`}>
                        {!isOpen?"Continue Editing":"Preview"}</button>
                    <button data-testid='save-lot' id="save-btn" onClick={(e)=>{e.preventDefault(); createLothandler()}}
                        disabled={isSaveDisabled()}
                        className=" bg-[#282828] rounded-md text-[14px] text-[#fff] disabled:cursor-auto
                        leading-normal font-medium px-[20px] py-[12px] w-[110px] md:w-[135px] hover:bg-[#626465]
                        disabled:bg-[#D4D4D8] disabled:text-[hsl(240,4%,65%)] flex justify-center"
                    >Save
                        {loading&& <Oval
                            height={20}
                            width={50}
                            color="#FFFFFF"
                            wrapperClass=""
                            visible={true}
                            ariaLabel='oval-loading'
                            secondaryColor="#000000"
                            strokeWidth={2}
                            strokeWidthSecondary={2}
                        />}
                    </button>
                </div>
            </nav>
            <SetUpForMobile setIsOpen={setIsOpen} isOpen={isOpen}
                lotData={lotData} edit={edit}
                auctionData={auctionData}
                setLotData={setLotData}
                priceError={priceError}
                setPriceError={setPriceError} 
                ismdBanner={isBanner}
                text={text} setText={setText}
                localImages={localImages} setLocalImages={setLocalImages}
                oldS3Images={oldS3Images} setOldS3Images={setOldS3Images}
                loading={loading}
            />
        </>
    );
}